import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import CanvasActions from "../../actions/CanvasActions.js";
import moment from "moment";

import heart from "../../assets/heart.png";

import "./style.css";

let canvas, ctx, planetarium, plancopy, oldTime;

class Canvas extends Component {
  componentDidMount() {
    canvas = this.refs.print;
    canvas.oncontextmenu = function(e) {
      e.preventDefault();
    };
    ctx = canvas.getContext("2d");

    setTimeout(() => {
      this.drawCanvas();
    }, 1000);

    var config = {
      width: this.props.canvas.scale * 700,

      projection: "airy",
      transform: "equatorial",

      adaptable: false,
      interactive: false,
      form: true,
      location: true,
      fullwidth: false,
      controls: false,
      lang: "en",
      container: "starmap",
      datapath: "./data",
      stars: {
        show: true,
        limit: 7,
        colors: false,
        style: {
          fill: "#ffffff",
          opacity: 1
        },
        names: false,
        proper: false,
        desig: false,
        size: 13,
        exponent: -0.33,
        data: "stars.6.json"
      },
      dsos: {
        show: false
      },
      planets: {
        show: false
      },
      constellations: {
        show: true,
        names: false,
        desig: false,
        lines: true,
        linestyle: { stroke: "#ffffff", width: 1, opacity: 1 },
        bounds: false
      },
      mw: {
        show: true,
        style: { fill: "#ffffff", opacity: 0.15 }
      },
      lines: {
        graticule: {
          show: true,
          stroke: "#ffffff",
          width: 2,
          opacity: 0.5
        },
        equatorial: { show: false },
        ecliptic: { show: false },
        galactic: { show: false }
      },
      background: {
        fill: this.props.canvas.backgroundColor,
        opacity: 0,
        stroke: "#000000",
        width: 1.5
      }
    };
    window.Celestial.display(config);
  }

  componentDidUpdate() {}

  drawCanvas() {
    let scale = this.props.canvas.scale;
    let width = scale == 1 ? 1000 : 1000 * scale,
      height = scale == 1 ? 1400 : 1400 * scale,
      borderWidth = scale == 1 ? 8 : 8 * scale,
      margin = scale == 1 ? 50 : 50 * scale,
      fontSize = scale == 1 ? 25 : 25 * scale;

    //fill

    ctx.fillStyle = this.props.backgroundColor;
    if (this.props.canvas.theme == 2 || this.props.canvas.theme == 3) {
      ctx.fillStyle = "#fff";
    }

    ctx.fillRect(0, 0, width, height);

    //draw white box
    ctx.fillStyle = "white";
    if (this.props.canvas.theme == 2 || this.props.canvas.theme == 3) {
      ctx.fillStyle = this.props.backgroundColor;
    }
    ctx.fillRect(margin, margin, width - margin * 2, height - margin * 2);

    //over fill white box
    ctx.fillStyle = this.props.backgroundColor;
    if (this.props.canvas.theme == 2 || this.props.canvas.theme == 3) {
      ctx.fillStyle = "#fff";
    }

    ctx.fillRect(
      borderWidth + margin,
      borderWidth + margin,
      width - borderWidth * 2 - margin * 2,
      height - borderWidth * 2 - margin * 2
    );

    ctx.font = fontSize + "px Helvetica";
    ctx.fillStyle = "#fff";
    if (this.props.canvas.theme == 2 || this.props.canvas.theme == 3) {
      ctx.fillStyle = this.props.backgroundColor;
    }
    ctx.textAlign = "center";
    //draw title
    let textTop = 0.8 * height;
    ctx.fillText(this.props.canvas.title, width / 2, textTop);
    // draw location text
    ctx.fillText(
      this.props.canvas.locationText,
      width / 2,
      textTop + fontSize * 1.5
    );
    // draw time date
    if (this.props.canvas.showTime) {
      ctx.fillText(
        `${moment(this.props.canvas.timeDate)
          .format("MMM Do YYYY")
          .toUpperCase()} at ${moment(this.props.canvas.timeDate)
          .format("hh:mm a")
          .toUpperCase()}`,
        width / 2,
        textTop + fontSize * 1.5 * 2
      );
    } else {
      ctx.fillText(
        moment(this.props.canvas.timeDate)
          .format("MMM Do YYYY")
          .toUpperCase(),
        width / 2,
        textTop + fontSize * 1.5 * 2
      );
    }
    // draw lat lng
    ctx.fillText(
      `${this.props.canvas.lat.toFixed(4)}N ${this.props.canvas.lng.toFixed(
        4
      )}W`,
      width / 2,
      textTop + fontSize * 1.5 * 3
    );
    //draw message
    let lines = this.props.canvas.message.match(/.{1,35}/g);
    ctx.textBaseline = "middle";
    if (lines) {
      var x = width / 2;
      var lineheight = fontSize * 1.3;
      var y = height * 0.7;
      for (var i = 0; i < lines.length; i++)
        ctx.fillText(
          lines[i],
          x,
          y + i * lineheight - (lines.length * lineheight) / 2
        );
    }

    //draw map

    if (window.Celestial.context) {
      if (this.props.canvas.theme == 3) {
        let img = new Image();
        img.src = heart;

        img.onload = () => {
          var offscreenCanvas = document.createElement("canvas");
          offscreenCanvas.width = 720 * this.props.canvas.scale;
          offscreenCanvas.height = 720 * this.props.canvas.scale;
          var context = offscreenCanvas.getContext("2d");

          context.drawImage(
            img,
            0,
            0,
            720 * this.props.canvas.scale,
            720 * this.props.canvas.scale
          );
          context.globalCompositeOperation = "source-in";
          context.drawImage(
            window.Celestial.context.canvas,
            -10 * this.props.canvas.scale,
            -60 * this.props.canvas.scale,
            780 * this.props.canvas.scale,
            780 * this.props.canvas.scale
          );

          ctx.drawImage(
            offscreenCanvas,
            (width - window.Celestial.context.canvas.width - 20) / 2,
            height * 0.1
          );
        };
      } else {
        ctx.drawImage(
          window.Celestial.context.canvas,
          (width - window.Celestial.context.canvas.width) / 2,
          height * 0.1
        );
      }
    }

    if (this.props.canvas.theme == 1 || this.props.canvas.theme == 2) {
      //draw circle
      ctx.strokeStyle = "#fff";
      if (this.props.canvas.theme == 2) {
        ctx.fillStyle = this.props.backgroundColor;
      }
      ctx.lineWidth = borderWidth;
      ctx.beginPath();
      ctx.arc(
        width / 2,
        height * 0.1 + window.Celestial.context.canvas.width / 2,
        window.Celestial.context.canvas.width / 2 -
          this.props.canvas.scale * 10,
        0,
        2 * Math.PI
      );
      ctx.stroke();
    }
  }

  render() {
    if (window.Celestial) {
      if (window.Celestial.rotate) {
        let date = new Date(
          this.props.canvas.year,
          this.props.canvas.month,
          this.props.canvas.day
        );

        window.Celestial.setDate(
          date,
          this.props.canvas.lat,
          this.props.canvas.lng
        );

        window.Celestial.apply({
          width: this.props.canvas.scale === 1 ? 700 : 2800,
          background: {
            fill: this.props.canvas.backgroundColor
          },

          constellations: {
            show: this.props.canvas.showConstellations
          },
          lines: {
            graticule: {
              show: this.props.canvas.showGrid,
              stroke: "#ffffff",
              width: 1,
              opacity: 0.8
            }
          }
        });

        setTimeout(() => {
          this.drawCanvas();
        }, 1000);
      }
    }

    return (
      <div className="canvas">
        <div className="canvas-wrapper">
          <div className="canvas-desk">
            <div className={this.props.canvas.frameAdded ? "frame" : ""}>
              <canvas
                id="print"
                ref="print"
                width={
                  this.props.canvas.scale === 1
                    ? 1000
                    : this.props.canvas.scale * 1000
                }
                height={
                  this.props.canvas.scale === 1
                    ? 1400
                    : this.props.canvas.scale * 1400
                }
              />
            </div>
            <div className="size rhs">
              {this.props.canvas.nonUS && this.props.canvas.printSize == 1 && (
                <span className="ind">45.7cm</span>
              )}
              {this.props.canvas.nonUS && this.props.canvas.printSize == 2 && (
                <span className="ind">61.0cm</span>
              )}

              {!this.props.canvas.nonUS && this.props.canvas.printSize == 1 && (
                <span className="ind">18"</span>
              )}
              {!this.props.canvas.nonUS && this.props.canvas.printSize == 2 && (
                <span className="ind">24"</span>
              )}
            </div>
          </div>
          <div className="size bottom">
            {this.props.canvas.nonUS && this.props.canvas.printSize == 1 && (
              <span className="ind">30.5cm</span>
            )}
            {this.props.canvas.nonUS && this.props.canvas.printSize == 2 && (
              <span className="ind">45.7cm</span>
            )}

            {!this.props.canvas.nonUS && this.props.canvas.printSize == 1 && (
              <span className="ind">12"</span>
            )}
            {!this.props.canvas.nonUS && this.props.canvas.printSize == 2 && (
              <span className="ind">18"</span>
            )}
          </div>
          <div id="starmap">
            <div id="celestial-form" />
          </div>
          <div className="size-mobile">
            {this.props.canvas.nonUS && this.props.canvas.printSize == 1 && (
              <span>30.5x45.7cm</span>
            )}
            {this.props.canvas.nonUS && this.props.canvas.printSize == 2 && (
              <span>45.7x61.0cm</span>
            )}

            {!this.props.canvas.nonUS && this.props.canvas.printSize == 1 && (
              <span>12" x 18"</span>
            )}
            {!this.props.canvas.nonUS && this.props.canvas.printSize == 2 && (
              <span>18" x 24"</span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    backgroundColor: state.canvas.backgroundColor,
    canvas: state.canvas
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setCanvas: canvas => {
      dispatch(CanvasActions.setCanvas(canvas));
    }
  };
};

const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(Canvas);

export default App;



// WEBPACK FOOTER //
// ./src/components/Canvas/index.js